import React, { Component } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom'

import Footer from "../Footer/Footer"
import Article from "../Article/Article"
import Homepage from "../Homepage/Homepage"

class App extends Component {
  constructor() {
    super();
    this.state = {
      scrollY: 0
    }
  }
  componentWillMount() {
    window.addEventListener("scroll", () => {
      this.setState({
        isSlided: (window.scrollY > 0.1 * window.screen.height)
      })
    });
  }

  render() {
    return (
      <div className={`App${(this.state.isSlided ? " slided" : "")}`}>

        <Router basename="/">
          <div>
            <Route exact path="/" component={Homepage} />
            <Route path="/article/:id" component={Article} />
            {/* <Route path="/article/:id" component={(route) => {
              <Article route={route} lastScroll={this.state.scrollY} />
            }} /> */}
            <Footer />
          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.js